import {Card} from 'platform/components';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {noop, suffixTestId, TestIdProps} from 'shared/web';

import {usePriceReport} from '../../../hooks/usePriceReport';
import i18n from '../../../i18n/i18n';
import {DrillDownLevelName, DrillDownStatisticsLevel} from '../../../types/api/drillDown';
import {DrillDown} from '../../DrillDown/components/DrillDown/DrillDown';
import {getFiltersFromFormData} from '../utils/getFiltersFromFormData';
import {useCreatePageContext} from './CreatePageContext';

export function DrillDownPicker(props: TestIdProps) {
  const {requestData} = usePriceReport();
  const {control, formApi, values} = useCreatePageContext();
  const market = requestData?.market;
  const hiddenLevels: DrillDownLevelName[] = [
    'make',
    'model_family_group',
    'model',
    'mileage_range',
  ];
  const initialLevelOrder: DrillDownLevelName[] = [
    'make',
    'model_family_group',
    'model',
    'year',
    'fuel_type',
    'transmission',
    'drive',
    'power',
    'car_style',
    'mileage_range',
  ];
  const filters = getFiltersFromFormData(values);
  const permanentFilters = {
    make: filters.make,
    model: filters.model,
  };
  const selectedRow = {
    make: filters.make,
    model_family_group: undefined,
    model: filters.model,
    year: filters.year,
    fuel_type: filters.fuel_type,
    transmission: filters.transmission,
    drive: filters.drive,
    power: filters.power,
    car_style: filters.car_style,
    mileage_range: undefined,
  };

  const onDrillDownRowSelect = (levels: DrillDownStatisticsLevel[]) => {
    levels.forEach((level) => {
      match<DrillDownLevelName, void>(level.name)
        .with('year', () => formApi.setValue('firstRegistrationOnYear', Number(level.value)))
        .with('fuel_type', () => formApi.setValue('fuelType', [level.value]))
        .with('transmission', () => formApi.setValue('transmission', [level.value]))
        .with('drive', () => formApi.setValue('drive', [level.value]))
        .with('power', () => formApi.setValue('power', Number(level.value)))
        .with('car_style', () => formApi.setValue('bodyStyle', [level.value]))
        .otherwise(noop);
    });
    control.onChange();
  };

  if (isNil(market)) {
    return null;
  }

  return (
    <Card
      title={i18n.t('page.create.labels.createDrillDown')}
      variant="inlineGrey"
      isExpandable
      isClosedByDefault
    >
      <DrillDown
        regions={[market]}
        currency="CZK" // We don't know currency, but we are not going to use prices
        hiddenLevels={hiddenLevels}
        initialLevelOrder={initialLevelOrder}
        permanentFilters={permanentFilters}
        selectedRow={selectedRow}
        boldFontForSelectedRowOnly
        hideConfigurator
        isSimplified
        onSelect={onDrillDownRowSelect}
        data-testid={suffixTestId('createDrillDown', props)}
      />
    </Card>
  );
}
